/*
  The commented out text above each variable
  should match the condition's name in Kentico
  and the variable key should match its codename
*/
export const petInsuranceConditions = {
    // User has selected or waived Pet coverage
    pet_condition_has_selected_or_waived_pi_covg: (data) => {
        return Boolean(data.user.pet.selectionStatus === 'Selected' ||
            data.user.pet.selectionStatus === 'Waived');
    },
    // Plan has accident and illness coverage
    pet_condition_plan_has_accident_and_illness: (data) => {
        return isAccidentPlusIllness(data);
    },
    // Plan has a wellness buy-up
    pet_condition_plan_has_wellness_buyup: (data) => {
        return Boolean(data.plan.hasWellnessCoverage && data.plan.wellnessBuyup);
    },
    // Plan has wellness coverage included
    pet_condition_plan_has_wellness_included: (data) => {
        return Boolean(data.plan.hasWellnessCoverage && !data.plan.wellnessBuyup);
    },
    // User has seen the plan explanation content
    pet_condition_has_seen_plan_exp: (data) => {
        return data.user.pet.seenPlanExp === true;
    },
    // User hasn't seen the plan explanation content
    pet_condition_hasnt_seen_plan_exp: (data) => {
        return data.user.pet.seenPlanExp !== true;
    },
    // Plan has illness coverage OR wellness coverage
    pet_condition_plan_covg_illness_or_wellness: (data) => {
        return Boolean(isAccidentPlusIllness(data) || data.plan.hasWellnessCoverage);
    },
    // Plan has enrollment link
    pet_condition_plan_has_enrollment_link: (data) => {
        return Boolean(data.plan.showEnrollmentUrl);
    },
    // User has selected pet coverage
    pet_condition_has_selected_pi_covg: (data) => {
        return Boolean(data.user.pet.selectionStatus === 'Selected');
    },
    // User has not made a decision about pet coverage yet
    pet_condition_has_not_made_pi_covg_decision: (data) => {
        return (data.user.pet.selectionStatus !== 'Selected' &&
            data.user.pet.selectionStatus !== 'Waived');
    },
    // Plan only has accident coverage
    pet_condition_plan_covg_accident_only: (data) => {
        return Boolean(data.plan.coverageType === 'accident');
    },
    // Plan has enrollment link OR allows enrollment any time
    pet_condition_plan_enrollment_link_or_anytime_enroll: (data) => {
        return Boolean(data.plan.showEnrollmentUrl || isAnytimeEnrollment(data));
    },
    // Plan allows employees to enroll anytime
    pet_condition_plan_enrollment_anytime: (data) => {
        return Boolean(isAnytimeEnrollment(data));
    },
};
function isAccidentPlusIllness(data) {
    return data.plan.coverageType === 'accident_illness';
}
function isAnytimeEnrollment(data) {
    return data.plan.enrollment === 'anytime';
}
//# sourceMappingURL=petInsurance.js.map